import { fmtDate } from "@/lib/format";
import { L } from "@/i18n";
import { Panel } from "@/components/dashboard/Panel";

const Row = ({ label, value, testId }) => (
  <div className="py-2.5 border-b border-[#1e293b]/70 last:border-0">
    <dt className="font-mono text-[10px] uppercase tracking-[0.15em] text-slate-500">{label}</dt>
    <dd className="mt-1 text-sm text-slate-200 break-words" data-testid={testId}>{value || "—"}</dd>
  </div>
);

const yesNo = (v) => (v ? L("Yes", "Sim") : L("No", "Não"));

export const StudentInfo = ({ user }) => (
  <Panel title={L("Student details", "Dados do aluno")} testId="student-info">
    <dl className="-my-2.5">
      <Row label={L("Registered", "Data de registo")} value={fmtDate(user.created_at, "dd MMM yyyy, HH:mm")} testId="student-created-at" />
      <Row label={L("Approved on", "Aprovado em")} value={user.approved_at && fmtDate(user.approved_at, "dd MMM yyyy, HH:mm")} testId="student-approved-at" />
      <Row label={L("Phone", "Telefone")} value={user.phone} testId="student-phone" />
      <Row label={L("Name on certificate", "Nome no certificado")} value={user.full_name_certificate} testId="student-cert-name" />
      <Row label={L("Date of birth", "Data de nascimento")} value={user.date_of_birth} testId="student-dob" />
      <Row label={L("Place of birth", "Local de nascimento")} value={user.place_of_birth} testId="student-pob" />
      <Row label={L("ID / Passport", "ID / Passaporte")} value={user.id_passport} testId="student-id-passport" />
      <Row label={L("Address", "Morada")} value={user.address} testId="student-address" />
      <Row label={L("Email verified", "Email verificado")} value={yesNo(user.email_verified)} testId="student-email-verified" />
      <Row label={L("Exams enabled", "Exames ativos")} value={yesNo(user.exams_enabled)} testId="student-exams-enabled" />
      <Row label={L("Last studied", "Último estudo")} value={[user.last_module, user.last_submodule].filter(Boolean).join(" · ")} testId="student-last-studied" />
    </dl>
  </Panel>
);
